module.exports = __webpack_public_path__ + "img/tpc-8.94932b9e.webp";